export const isValidEmail = (email: string) => {
  return email
    .toLowerCase()
    .match(
      /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
    );
};

export const isUrlWithProtocol = (value: any) => {
  return /(?:https?|http?):\/\/(\w+:?\w*)?(\S+)(:\d+)?(\/|\/([\w#!:.?+=&%!\-\/]))?$/i.test(value);
};

export const isNumber = (str: any) => {
  return /^\d+$/.test(str);
};

export const isValidDomain = (domain: any) => {
  return /^((?:(?:(?:https?|http?):\/\/(\w[\.\-\+]?)*)\w)+)((?:(?:(?:\w[\.\-\+]?){0,62})\w)+)\.(\w{2,6})$/i.test(domain);
};

export const landingPageParams = (params: any) => {
  return /^\??([\w-.{}]+(=[\w-.{}]*)+(&[\w-.{}]+(=[\w-.{}]*))*)?$/i.test(params);
};

export const isNotEmpty = (value: string) => {
  return value !== '';
};

export const isValidZipCode = (zipCode: string) => {
  return !zipCode || /(^\d{5}$)|(^\d{5}-\d{4}$)/.test(zipCode);
};
